import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { LazyLinkSignatureService } from './services/lazy-link-signature-service.interface';
import { LazyLinkSignatureServiceImpl } from './services/lazy-link-signature-service';
import { LazyLinkSignatureRepository } from './repositories/lazy-link-signature-repository.interface';
import { LazyLinkApi } from './repositories/apis/lazy-link-api.interface';
import { LazyLinkApiImpl } from './repositories/apis/lazy-link-api';
import { LazyLinkSignatureRepositoryImpl } from './repositories/lazy-link-signature-repository';
export const lazyLink = new ContainerModule(bind => {
    bind(LazyLinkSignatureService).to(LazyLinkSignatureServiceImpl);
    bind(LazyLinkSignatureRepository).to(LazyLinkSignatureRepositoryImpl);
    bind(LazyLinkApi).to(LazyLinkApiImpl);
});
